import { AsyncComponent } from '@frontend/components/common';
import { ProductType } from '@frontend/product/types';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

import ProductCreateRedirect from '../product/product-create/product-create-redirect.component';

const ServiceDetail = lazy(() => import('./service-detail/service-detail.component'));
const ServiceUpdate = lazy(() => import('./service-update/service-update.component'));

export function ServiceRoutes() {
    return (
        <Route path='services'>
            <Route
                index
                element={
                    <Navigate
                        to='../products?tab=service'
                        replace
                    />
                }
            />
            <Route
                path='create'
                element={<ProductCreateRedirect type={ProductType.SERVICE} />}
            />
            <Route path=':serviceId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ServiceDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ServiceUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
